export const CREATE = 0;
export const EDIT = 1;

export const FORM_TITLE = {
    [CREATE] : "شرکت جدید",
    [EDIT] : "ویرایش شرکت",
}

export const BUTTON_TITLE = {
    [CREATE] : "ایجاد شرکت",
    [EDIT] : "ویرایش شرکت",
}